import React from 'react'
import { IconMaps } from '@ow/icons'
import Icon from './Icon'

const Content = function ({ prefix, useLoginApi, loginCallBack }) {
  const {
    errors,
    passwordOk,
    usernameOk,
    registerUserName,
    registerPassword,
    inputOnKeyDown,
  } = useLoginApi

  return (
    <form className="w-full">
      <h1 className={`${prefix}-inputTitle`}>用户名</h1>
      <div className={`${prefix}-inputPhoneBox input-text input-${prefix}`}>
        <div>
          <IconMaps
            type="loginUserNameIcon"
            width={16}
            height={16}
            fill="gray"
          />
          <div className="flex-1 h-4/5 flex flex-col justify-between ml-2">
            <input
              {...registerUserName()}
              autoComplete="off"
              className={`${prefix}-inputPhone phone login-input`}
              onKeyUp={(e) => {
                inputOnKeyDown(e, loginCallBack)
              }}
            />
          </div>
          {usernameOk && (
            <Icon
              width="15"
              color="#00aa33"
              className={`${prefix}-inputPass`}
              path="M512 1024C229.230592 1024 0 794.769408 0 512S229.230592 0 512 0s512 229.230592 512 512-229.230592 512-512 512zM254.12608 528.77312l172.396544 174.733312a0.607232 0.607232 0 0 0 0.864256 0.01536l342.540288-343.36768a0.311296 0.311296 0 0 0-0.003072-0.44032l-37.359616-37.285888a0.320512 0.320512 0 0 0-0.443392-0.02048l-304.47616 277.743616c-0.37376 0.340992-0.996352 0.357376-1.381376 0.027648L294.8608 487.48544a0.339968 0.339968 0 0 0-0.452608 0.022528l-40.27904 40.824832a0.3072 0.3072 0 0 0-0.004096 0.44032z"
            />
          )}
        </div>
        {errors && errors.userName && (
          <span className={`${prefix}-error-tip`}>
            {errors.userName.message}
          </span>
        )}
      </div>

      <h1 className={`${prefix}-inputTitle`}>密码</h1>
      <div className={`${prefix}-inputPwdBox input-text input-${prefix}`}>
        <div>
          <IconMaps
            type="loginPasswordIcon"
            width={16}
            height={16}
            fill="gray"
          />
          <div className="flex-1 h-4/5 flex flex-col justify-between ml-2">
            <input
              {...registerPassword()}
              autoComplete="new-password"
              type="password"
              className={`${prefix}-inputPwd login-input pwd-${prefix}`}
              placeholder="请输入密码"
              onKeyUp={(e) => {
                inputOnKeyDown(e, loginCallBack)
              }}
            />
          </div>
          {passwordOk && (
            <Icon
              width="15"
              color="#00aa33"
              className={`${prefix}-inputPass`}
              path="M512 1024C229.230592 1024 0 794.769408 0 512S229.230592 0 512 0s512 229.230592 512 512-229.230592 512-512 512zM254.12608 528.77312l172.396544 174.733312a0.607232 0.607232 0 0 0 0.864256 0.01536l342.540288-343.36768a0.311296 0.311296 0 0 0-0.003072-0.44032l-37.359616-37.285888a0.320512 0.320512 0 0 0-0.443392-0.02048l-304.47616 277.743616c-0.37376 0.340992-0.996352 0.357376-1.381376 0.027648L294.8608 487.48544a0.339968 0.339968 0 0 0-0.452608 0.022528l-40.27904 40.824832a0.3072 0.3072 0 0 0-0.004096 0.44032z"
            />
          )}
        </div>
        {errors && errors.password && (
          <span className={`${prefix}-error-tip`}>
            {errors.password.message}
          </span>
        )}
      </div>
    </form>
  )
}
export default Content
